import { plainToClass } from 'class-transformer';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export declare type ClassConstructor<T> = {
  new (...args: unknown[]): T;
};

export function useSerializedState<T, V>(cls: ClassConstructor<T>, initialState: V | (() => V)): [T | undefined, Dispatch<SetStateAction<V | undefined>>];
export function useSerializedState<T>(cls: ClassConstructor<T>): [T | undefined, Dispatch<SetStateAction<T>>];
export function useSerializedState<T, V>(cls: ClassConstructor<T>, initialState?: V | (() => V)): [T | undefined, Dispatch<SetStateAction<V | undefined>>] {
  const [raw, setRaw] = useState(initialState);
  const [instantiated, setInstantiated] = useState(plainToClass(cls, raw));

  useEffect(() => {
    setInstantiated(plainToClass(cls, raw));
  }, [raw, cls]);

  return [instantiated, setRaw];
}
